import React from 'react';

/**
 * Renders children regardless of session/guest state.
 * Replaces caribe7/PrivateRoute (no access control logic).
 */
const PrivateRoute = ({ children }: { children: React.ReactNode }) => children;

export default PrivateRoute;
